export default __webpack_public_path__ + "static/media/tricycle.89652830.png";